import React from 'react';
import { useMutation, useQuery } from '@apollo/react-hooks';

// Queries
import {
  MESSAGES_QUERY,
} from '../../graphql/queries';

// Mutations
import {
  MUTATION_ADD_MESSAGE,
} from '../../graphql/mutations';
import Messages from './Messages';
import TipTapEditor from 'components/tiptap-editor/TipTapEditor';

const Chat = ({ productId }) => {
  const [messageContent, setMessageContent] = React.useState("");

  const {
    data: messagesData,
    loading: messagesLoading,
    error: messagesError,
    refetch: messagesRefetch,
  } = useQuery(MESSAGES_QUERY, {
      variables: {
        productId,
      },
      fetchPolicy: 'cache-and-network',
  });
  const [
    createMessageMutation,
  ] = useMutation(MUTATION_ADD_MESSAGE, {
    refetchQueries: () => messagesRefetch(),
    awaitRefetchQueries: true,
    onCompleted: () => {
      setMessageContent("");
    },
  });

  const messages = messagesData?.messages || [];

  return (
    <div style={{ marginBottom: 32 }}>
      <h3>Produktkommentarer mellan Kvalitetsgranskning och Producent</h3>
      <Messages
        loading={messagesLoading}
        isError={!!messagesError}
        messages={messages}
      />
      <TipTapEditor
        html={messageContent}
        onSubmit={async (html) => {
          await createMessageMutation({
            variables: { input: { productId, html } },
          });
        }}
      />
    </div>
  );
};

export default Chat;
